<template>
    <div class="InvoiceItem">
        <div class="InvoiceItem-leftContainer">
            <img
                v-if="car"
                class="InvoiceItem-carPicture"
                :src="`/api/media/${car.picture.slug}`"
                alt="car"
            >
            <div
                v-else
                class="InvoiceItem-carPicture InvoiceItem-carPicture--placeholder"
            >
                <span :class="servicePlaceholderIcon" />
            </div>
            <div class="InvoiceItem-infoContainer">
                <span
                    v-if="car"
                    class="InvoiceItem-carModel"
                >
                    {{ car.make }} {{ car.model }}
                </span>
                <div class="InvoiceItem-dateContainer">
                    <span class="InvoiceItem-date">
                        {{ dateFormat(invoice.created) }}
                    </span>
                    <Tag
                        v-if="isUnpaid"
                        type="warning"
                        class="InvoiceItem-unpaid"
                    >
                        {{ $t('personal-account.invoices.unpaid') }}
                    </Tag>
                </div>

                <a
                    class="InvoiceItem-number"
                    :href="`/invoices/${invoice._id}?key=${invoice.key}`"
                >
                    {{ invoice.number || invoice.reference }}
                </a>
            </div>
        </div>
        <div class="InvoiceItem-rightContainer">
            <div class="InvoiceItem-price">
                {{ amount }}
            </div>
            <div class="InvoiceItem-serviceType">
                {{ serviceType }}
            </div>
        </div>
    </div>
</template>
<script>
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
dayjs.extend(localizedFormat)
import _ from "lodash";
import money from "@free2move/money";
import Tag from "@/components/Tag.vue";

export default {
    components:{
        Tag
    },
    props: {
        invoice: {
            type: Object,
            required: true
        }
    },
    computed: {
        amount() {
            return new money({...this.invoice.grandTotal, language: this.$language}).format();
        },
        serviceType() {
            return this.$t('personal-account.invoices.service.' + (this.invoice.modelHolder ? this.invoice.modelHolder.split('+')[0] : 'other'));
        },
        car() {
            return _.get(this.invoice, 'rent.car')
                || _.get(this.invoice, 'carsharing.car')
                || _.get(this.invoice, 'codContract.offer');
        },
        fromDate() {
            return _.get(this.invoice, 'rent.from.date')
                || _.get(this.invoice, 'carsharing.from.date')
                || _.get(this.invoice, 'refill.created')
                || _.get(this.invoice, 'created');
        },
        toDate() {
            return _.get(this.invoice, 'rent.to.date')
                || _.get(this.invoice, 'carsharing.to.date');
        },
        servicePlaceholderIcon() {
            const service = this.invoice.modelHolder ? this.invoice.modelHolder?.split('+')[0] : 'other';
            switch (service) {
                case 'rent':
                    return 'f2m-rent-car';
                case 'carsharing':
                    return 'f2m-carsharing-car';
                case 'refill':
                    return 'f2m-gas';
                case 'cod-contract-v-2':
                    return 'f2m-cod-car';
                default:
                    return 'f2m-invoice';
            }
        },
        isUnpaid() {
            return ['open', 'recovery'].includes(this.invoice.status) && this.invoice.type === 'debit';
        }
    },
    methods: {
        dateFormat(date) {
            return dayjs(date).format('L');
        }
    }

}
</script>
<style lang="scss" scoped>
.InvoiceItem {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:last-child {
        border-bottom: none;
    }

    &-rightContainer {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 4px;
        color: $color-f2m-blue;
    }
    &-serviceType {
        background: #EDF2FF;
        border-radius: 10px;
        padding: 3px 10px;
    }
    &-price {
        font-size: 18px;
        line-height: 22px;
    }

    &-leftContainer {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 14px;
    }
    &-icon {
        font-size: 24px;
        color: #573781;
    }

    &-number {
        text-overflow: ellipsis;
        color: $color-f2m-pink;
        overflow: hidden;
        max-width: 200px;

        @media (max-width: $f2m-desktop-breakpoint) {
            max-width: calc(100vw - 250px);
        }
    }

    &-date {
        font-size: 14px;
        line-height: 17px;
        color: #8D86B6;
    }

    &-infoContainer {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: left;
    }

    &-carPicture {
        width: 60px;
        height: 60px;
        object-fit: contain;

        &--placeholder {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 24px;
            border-radius: 50%;
            background: #EDF2FF;
            color: $color-f2m-blue;
        }
    }
    &-carModel {
        font-size: 18px;
        line-height: 22px;
        letter-spacing: 0.3px;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 200px;
        white-space: nowrap;

        @media (max-width: $f2m-desktop-breakpoint) {
            max-width: calc(100vw - 250px);
        }

    }
    &-unpaid {
        margin-left: 8px;
    }
}
</style>
